import { graphql } from '@teachino/shared-infrastructure';

export const changeVisibilityMutation = graphql(`
  mutation ToogleMaterialVisibility(
    $materialId: String!
    $courseId: String!
    $contentVisibility: ContentVisibility!
  ) {
    toggleCourseMaterialVisibility(
      visibilityToggleInput: {
        courseId: $courseId
        materialId: $materialId
        contentVisibility: $contentVisibility
      }
    ) {
      done
    }
  }
`);
